/**
 * READ-mode kotwica wizualna -- tekstowa wartość ze stylem dopasowanym do EDIT inputów.
 * "—" rysowany odmiennym (szarszym) stylem dla pustych pól.
 */
export function ReadValuePlaceholder({ display }: { display: string }) {
  const empty = display === '—'
  return (
    <div
      className={[
        'text-sm min-h-[2.25rem] flex items-center px-3 py-2 rounded-md border border-dashed',
        empty
          ? 'text-slate-400 border-slate-200 bg-slate-50/50'
          : 'text-slate-900 font-medium border-slate-200 bg-slate-50/40',
      ].join(' ')}
    >
      {display}
    </div>
  )
}
